/**
 * iter317 — Phase 7B: `useFeature(key)` hook.
 *
 * Thin wrapper around <FeatureContext>'s `isPlanFeatureEnabled` to
 * give pages / components a single hook that returns:
 *
 *   { enabled, loading, prompt }
 *
 * `enabled` is the boolean gate value (true while loading — fail-open
 * matches the existing FeatureContext behaviour).
 *
 * `prompt(actionLabel?)` triggers the global UpgradeModal. Use this
 * on click handlers as a guard:
 *
 *   const { enabled, prompt } = useFeature('tournaments.registrations');
 *   const handleCreate = () => {
 *     if (!enabled) return prompt('Create a tournament');
 *     ...
 *   };
 */
import { useFeatures } from '../context/FeatureContext';
import { promptUpgrade } from '../lib/upgradePrompt';

export function useFeature(featureKey) {
  const ctx = useFeatures();
  const enabled = ctx.isPlanFeatureEnabled(featureKey);
  return {
    enabled,
    loading: ctx.loading,
    planFeatures: ctx.planFeatures,
    prompt: (actionLabel) => promptUpgrade(featureKey, actionLabel),
  };
}

export default useFeature;
